import { all, put, select, race, take, takeEvery, takeLatest } from 'redux-saga/effects'
import { SUCCESS, FAILED } from 'crom-api-constants'
import _ from 'lodash'

import config from '@config'

import { getToken, getLocale } from '@global/selectors'

import { BLOCK_DATA_LOADED } from '../../../../../../../components/Workspace/components/HocBlock/constants'
import {
    blockDataTransformed,
    blockSaveCustomData,
} from '../../../../../../../components/Workspace/components/HocBlock/actions'

import {
    GRANTS_TABLE_CHANGE,
    GRANTS_TABLE_CHANGE_REQUEST,
    GRANTS_TABLE_DATA_RECEIVED,
    GRANTS_TABLE_LOADING_TRUE,
    GRANTS_TABLE_LOADING_FALSE,
} from './constants'

import {
    grantsTableDataReceived,
    grantsTableChangeRequest,
    grantsTableLoadingTrue,
    grantsTableLoadingFalse,
} from './actions'

const GRANTS_TABLE_CHANGE_REQUEST_SUCCESS = (id) => `${GRANTS_TABLE_CHANGE_REQUEST(id)}_${SUCCESS}`
const GRANTS_TABLE_CHANGE_REQUEST_FAILED = (id) => `${GRANTS_TABLE_CHANGE_REQUEST(id)}_${FAILED}`

function* onDataLoaded(_action) {
    const blockKey = _.get(_action, 'data.blockKey', null)
    if (blockKey !== config.modules.report.blocks.dotace.key) return null

    const module = _.get(_action, 'data.module', null)
    const id = _.get(_action, 'data.id', null)
    if (!module || !id || !blockKey) return null

    const data = _.get(_action, 'data.data', null)

    const transformedData = {
        ..._.get(data, '[0]', {}),
        grants: _.map(_.get(data, '[1].table', {}), (row) => ({ ...row })),
        query: _.get(data, '[1].query', {}),
    }

    yield put(blockDataTransformed(module, id, blockKey, transformedData))

    yield put(
        blockSaveCustomData(module, id, blockKey, {
            isLoading: false,
            data: _.map(_.get(_action, 'data.data[1].table'), (row) => ({ ...row })),
            pagination: _.get(_action, 'data.data[1].query.pagination', {}),
            sorted: _.get(_action, 'data.data[1].query.sort.sortedColumns', []),
        })
    )

    return null
}

function* grantsTableSaga(action) {
    const module = _.get(action, 'data.module', null)
    const blockKey = _.get(action, 'data.blockKey', null)
    const id = _.get(action, 'data.id', null)
    const level = _.get(action, 'data.level', null)
    const queryParams = _.get(action, 'data.queryParams', null)
    const customData = _.get(action, 'data.customData', {})

    const locale = yield select(getLocale)
    const token = yield select(getToken, id, module)

    const lang = config.languages[locale].requestKey

    if (!module || !blockKey || !id || !level) return null

    yield put(grantsTableLoadingTrue(module, id, blockKey, { ...customData, isLoading: true }))

    const qp = {
        // filters: [],
        'sort[]': _.map(_.get(queryParams, 'sorted', []), (val) => `${_.get(val, 'id')}${val.desc ? ':desc' : ':asc'}`),
        page: _.get(queryParams, 'pagination.page'),
        rows: _.get(queryParams, 'pagination.rowsPerPage'),
    }

    yield put(grantsTableChangeRequest(module, blockKey, id, level, lang, token, qp))

    const response = yield race({
        success: take(GRANTS_TABLE_CHANGE_REQUEST_SUCCESS(id)),
        failed: take(GRANTS_TABLE_CHANGE_REQUEST_FAILED(id)),
    })

    if (!response.failed) {
        const data = _.map(_.get(response, 'success.payload.response.body.table'), (row) => ({ ...row }))
        const query = _.get(response, 'success.payload.response.body.query', [])
        const pagination = _.get(query, 'pagination', null)
        const sorted = _.reduce(
            _.get(query, 'sort.sortedColumns'),
            (acc, val) => [
                ...acc,
                {
                    id: _.get(val, 'columm'), // TYPO FROM BACKEND
                    desc: _.get(val, 'direction') === 'desc',
                },
            ],
            []
        )

        const newCustomData = {
            ...customData,
            data,
            pagination,
            sorted,
            isLoading: false,
        }

        yield put(grantsTableDataReceived(module, id, blockKey, newCustomData))
    } else {
        yield put(grantsTableLoadingFalse(module, id, blockKey, { ...customData, isLoading: false }))
    }

    return null
}

function* grantsChangeCustomData(action) {
    const blockKey = _.get(action, 'data.blockKey', null)
    if (blockKey !== config.modules.report.blocks.dotace.key) return null

    const module = _.get(action, 'data.module', null)
    const id = _.get(action, 'data.id', null)
    if (!module || !id || !blockKey) return null

    const customData = _.get(action, 'data.customData', null)

    yield put(blockSaveCustomData(module, id, blockKey, customData))

    return null
}

export default function* blockTransformSaga() {
    yield all([
        takeEvery(BLOCK_DATA_LOADED, onDataLoaded),
        takeLatest(GRANTS_TABLE_CHANGE, grantsTableSaga),
        takeEvery(GRANTS_TABLE_DATA_RECEIVED, grantsChangeCustomData),
        takeEvery(GRANTS_TABLE_LOADING_TRUE, grantsChangeCustomData),
        takeEvery(GRANTS_TABLE_LOADING_FALSE, grantsChangeCustomData),
    ])
}
